import { formatCurrencyV2 } from '@wix/domains-serverless-interface';
const currencySettingsDefault = {
  code: 'USD',
  decimalSeparator: '.',
  groupSeparator: ',',
  minorUnits: 2,
  negativePrefix: '- ¤',
  negativeSuffix: '',
  positivePrefix: '¤',
  positiveSuffix: '',
  symbol: '&#36;'
};
export const isInteractiveClickTarget = target => target instanceof Element && Boolean(target.closest('a, button, [role="button"], [role="link"]'));
export const formatPrice = _ref => {
  let amount = _ref.amount,
    _ref$currencySettings = _ref.currencySettings,
    currencySettings = _ref$currencySettings === void 0 ? currencySettingsDefault : _ref$currencySettings;
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (isNaN(numAmount)) {
    return '$0.00';
  }
  const formatter = formatCurrencyV2(String(numAmount), currencySettings);
  return formatter;
};
export const nextPageBoundaries = (boundaries, itemCount, isNewSearch) => {
  const base = isNewSearch ? [] : boundaries;
  const last = base.at(-1) ?? 0;
  if (itemCount < last) {
    return [itemCount];
  }
  if (itemCount > last) {
    return [...base, itemCount];
  }
  return base;
};
export const pageOfIndex = (boundaries, index) => boundaries.findIndex(boundary => index < boundary) + 1 || 1;
//# sourceMappingURL=utils.js.map